// HELPER FUNCTIONS

const findIndexById = (list, id) => {
  return list.reduce((result, obj, index) => {
    if(obj.id === id) {
      return index;
    };
    return result;
  }, -1);
};
const mergeObjs = (a, b) => ({ ...a, ...b });
const mergeArrs = (a, b) => [...a, ...b];

// CREATE STORE

const createStore = (initialState) => {
  let emptyState = {
    messages: [],
    loading: false,
  };

  const subscribers = [];
  let pageToken = '';
  let currentState = initialState || emptyState;
  let promise = null;

  const notifyObservers = () => {
    subscribers.forEach((o) => {
      o(currentState);
    });
  };
  const updateState = (update) => {
    currentState = mergeObjs(currentState, update);
  };
  const addMessages = (newMessages) => {
    const messages = [...currentState.messages, ...newMessages];
    const update = { messages };
    updateState(update);
  };
  const updateLoading = (isLoading) => {
    updateState({
      loading: isLoading,
    });
  }
  const deleteMessage = (id) => {
    const messages = currentState.messages;
    const index = findIndexById(messages, id);
    if (index > -1) {
      const updateMessages = mergeArrs(
        messages.slice(0, index),
        messages.slice(index + 1)
      );
      updateState({
        messages: updateMessages,
      });
      return true;
    } else {
      return false;
    }
  }

  return {
    subscribe: (subsciber) => {
      if (subscribers.indexOf(subsciber) === -1) {
        subscribers.push(subsciber);
      }
      return true;
    },
    getMoreMessages: () => {
      if (!promise) {
        updateLoading(true);
        notifyObservers();
        promise = fetch(`https://message-list.appspot.com/messages?pageToken=${pageToken}`)
          .then(function(response) {
            if(response.ok) {
              return response.json();
            }
            throw new Error('Network response was not ok.');
          })
          .then((response) => {
            promise = null;
            pageToken = response.pageToken;
            addMessages(response.messages);
            updateLoading(false);
            notifyObservers();
            return response
          })
          .catch((err) => {
            promise = null;
            updateLoading(false);
            notifyObservers();
            throw err;
          });
      }

      return promise;
    },
    getState: () => {
      return currentState;
    },
    deleteMessage: (id) => {
      const deleted = deleteMessage(id);
      if (deleted) {
        notifyObservers();
        return true;
      } else {
        return false;
      }
    },
  };
};

export default createStore;



// WEBPACK FOOTER //
// ./src/messageStore/index.js